//import Libraries
import React, {Component} from 'react';
import {storageRef} from '../../../../../firebase';
import * as axios from 'axios';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Row, Col, Form, FormGroup, Label, Input} from 'reactstrap'
import ImageSelector from '../../ImageSelector/ImageSelector';

import QuillEditor from '../../QuillEditor/QuillEditor';

import EditConfirmButton from '../../EditConfirmButton/EditConfirmButton';
import UpDownButton from '../../UpDownButton/UpDownButton';

import * as homepageActions from '../../../HomepageManager/actions/homepageActions';
import * as departmentActions from '../../../HomepageManager/actions/departmentActions';
import * as htmlActions from '../../../actions/htmlActions';
import { storage } from 'firebase';


class CardItemFormLine extends Component{

    constructor(props) {
        super(props);

        const {data} = props;

        this.state = {
            editing : false,

            koName: data.name['ko'],
            koContent: data.content['ko'],
            enName: data.name['en'],
            enContent: data.content['en'],
            text : '',
            imageCount : data.imageCount ? data.imageCount : 0,
            shouldDeletes : []
        }
    }

    addShouldDeletes = (id) => {
        let shouldDeletes = [...this.state.shouldDeletes];
        if(shouldDeletes.indexOf(id) === -1){
            shouldDeletes.push(id);
            this.setState(prevState => ({
                shouldDeletes,
                imageCount : prevState.imageCount - 1
            }))
        }
    }
    removeShouldDeletes =  (id) => {
        let shouldDeletes = [...this.state.shouldDeletes]; 
        const index = shouldDeletes.indexOf(id);
        if(index !== -1) {
            shouldDeletes.splice(index, 1);    
            this.setState(prevState => ({
                shouldDeletes,
                imageCount : prevState.imageCount + 1
            }))
        }
    }
    handleQuillChange=(value) => {
        this.setState({ text: value })
    }
    setImageCount = (value) => {
        this.setState({
            imageCount : value
        })
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!prevState.editing && this.state.editing) {
            this.loadText()
        }

        if(prevProps.data.id !== this.props.data.id) {
            const {data} = this.props;
            this.setState({
                editing : false,
    
                koName: data.name['ko'],
                koContent: data.content['ko'],
                enName: data.name['en'],
                enContent: data.content['en'],
                text : '',
                imageCount : data.imageCount ? data.imageCount : 0,
                shouldDeletes : []
            });
        }
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    loadText = () => {
        const cardRef = storageRef.child(`cards/${this.props.data.id}.html`);
        cardRef.getDownloadURL()
            .then((url) => {
                console.log('getet')
                axios.get(url, {
                })
                    .then((res) => {
                        this.setState({
                            text : res.data
                        })
                    })
                    .catch((e)=>{
                    })
            })
            .catch((e) => {
            })
    }

    render() {
        const {koName, koContent, enName, enContent} = this.state;
        const { index, data, storagePath } = this.props;

        const {editing} = this.state;

        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <ImageSelector
                            storagePath={storagePath}
                            imageId={data.id}
                        />
                    </Col>
                    <Col>
                        <Form>
                            <FormGroup>
                                <Label className="mr-sm-2">제목</Label>
                                <Input
                                    type="text"
                                    name={'koName'}
                                    value={koName}
                                    onChange={this.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="mr-sm-2">미리보기</Label>
                                <Input
                                    type="text"
                                    name={'koContent'}
                                    value={koContent}
                                    onChange={this.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col>
                        <Form>
                            <FormGroup>
                                <Label className="mr-sm-2">Title</Label>
                                <Input
                                    type="text"
                                    name={'enName'}
                                    value={enName}
                                    onChange={this.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label className="mr-sm-2">Preview</Label>
                                <Input
                                    type="text"
                                    name={'enContent'}
                                    value={enContent}
                                    onChange={this.handleOnChange}
                                    disabled={!editing}
                                    bsSize="sm"
                                />
                            </FormGroup>
                        </Form>
                    </Col>
                    <Col sm={1}>
                        <UpDownButton 
                            disabled={this.props.editAnything}
                            onOrderUp={() => {
                                this.props.onDataOrderSwitch(this.props.index, this.props.index - 1, this.props.dataArray);
                            }}
                            onOrderDown={() => {
                                this.props.onDataOrderSwitch(this.props.index, this.props.index + 1, this.props.dataArray);
                            }}
                        />

                        <EditConfirmButton 
                            editing={editing}
                            onConfirm={ () => {
                                this.props.onUpdate(this.props.dbPath, data.id, {
                                    name : {
                                        en : enName,
                                        ko : koName
                                    },
                                    content : {
                                        en : enContent,
                                        ko : koContent
                                    },
                                    imageCount : this.state.imageCount,
                                });
                                this.props.onUpdateHTML('cards', data.id, this.state.text,
                                    () => {
                                        console.log('success');
                                    },
                                    () => {
                                        console.log('failed');
                                    }
                                );
                                this.props.onDeleteUnusedImages('card_images', data.id, this.state.shouldDeletes)
                            }}
                            onToggleEditing={() => {
                                this.setState((prevstate) => ({
                                    editing : !prevstate.editing,
                                    text : ''
                                }))
                            }}
                            onRemove={() => {
                                this.props.onRemoveFormLine(data.id);
                                this.props.onRemove(this.props.dbPath, this.props.storagePath, {
                                    id : data.id
                                })
                                this.props.onDeleteHTML('cards', 'card_images', data.id, this.state.imageCount);
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    {
                        editing &&  
                            <QuillEditor
                                addShouldDeletes={this.addShouldDeletes}
                                removeShouldDeletes={this.removeShouldDeletes}
                                imageStoragePath="card_images"
                                id={this.props.data.id}
                                imageCount={this.state.imageCount}
                                setImageCount={this.setImageCount}
                                label="내용"
                                name="text"
                                value={this.state.text}
                                onChange={this.handleQuillChange}
                                disabled={editing}
                            />
                    }
                </Row>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateHTML : (storagePath, id, text, successFunc, failedFunc) => {
            dispatch(htmlActions.updateHTML(storagePath, id, text, successFunc, failedFunc));
        },
        onDeleteHTML : (textPath, imagePath, id, imageCount) => {
            dispatch(htmlActions.deleteHTML(textPath, imagePath, id, imageCount));
        },
        onDeleteUnusedImages : (storagePath, ids, shouldDeletes) => {
            dispatch(homepageActions.deleteUnusedImages(storagePath, ids, shouldDeletes));
        }, 
        onDataOrderSwitch : (aIndex, bIndex, dataArray) => {
            dispatch(departmentActions.departmentCardDataOrderSwitch(aIndex, bIndex, dataArray));
        }
    }
}

export default connect(null, mapDispatchToProps)(CardItemFormLine);



// WEBPACK FOOTER //
// ./src/pages/Admin/Components/AdminDepartmentFormManager/FormLines/CardItemFormLine.js